import { useDispatch } from 'react-redux';
import { logout } from '../Redux/Reducers/Auth/AuthSilice';
import { LuLogOut } from "react-icons/lu";
import { CgProfile } from "react-icons/cg";
import { Link } from 'react-router-dom';
import NotificationIcon from '../Assets/notifiaction.svg';
import StyledSidebarLayout from './style';
import { Badge } from '@mui/material';


function Header() {

    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(logout());
    };

    return (
        <StyledSidebarLayout>
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <Link to="#" className="nav-link" data-widget="pushmenu" role="button"><i className="fas fa-bars" /></Link>
                    </li>
                </ul>
                <div className="leftNavSec">
                    {/* <div className="icon">
                        <Badge badgeContent={2} color="error" className="badgeIcon">
                            <img src={NotificationIcon} alt='Notifiaction Bell' />
                        </Badge>
                    </div> */}
                    <div className="nav-item dropdown usermenu">
                        <Link to="#" data-toggle="dropdown">
                            <img src="/dist/img/download.png" alt="User Avatar" className="img-size-50 mr-3 img-circle" />
                        </Link>
                        <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                            <Link to="/profile" className="dropdown-item">
                                <CgProfile className='icon-size' /> Profile
                            </Link>
                            <button className="dropdown-item" onClick={handleLogout}>
                                <LuLogOut className='icon-size' /> Logout
                            </button>
                        </div>
                    </div>
                </div>
            </nav>
            {/* /.navbar */}
        </StyledSidebarLayout>
    )
}

export default Header
